import { render, staticRenderFns } from "./ModalEmpresa.vue?vue&type=template&id=24386db6&scoped=true"
import script from "./ModalEmpresa.vue?vue&type=script&lang=js"
export * from "./ModalEmpresa.vue?vue&type=script&lang=js"
import style0 from "./ModalEmpresa.vue?vue&type=style&index=0&id=24386db6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24386db6",
  null
  
)

export default component.exports